module.exports = __webpack_public_path__ + "img/mobile_girl_three.bda48777.png";